export default __webpack_public_path__ + "static/feature_04-7a6b6e12067120fb60490a8324284e9f.png";